import { toast } from "react-toastify";

export const handleError = (error) => {
  if (error.response && error.response.data && error.response.data.errors) {
    const errorMessages = error.response.data.errors
      .map((err) => err.message)
      .join("\n");
    toast.error(errorMessages);
  } else if (
    error.response &&
    error.response.data &&
    error.response.data.message
  ) {
    toast.error(error.response.data.message);
  } else {
    toast.error("An unexpected error occurred. Please try again later.");
  }

  console.error("Error:", error);
};
